<template>
    <v-app-bar app>
      <v-toolbar-title class="headline text-uppercase title">
        <!--v-icon>view_headline</v-icon-->
        <span @click="gohome">{{$store.state.appconfig.appname1}}</span>
        <span v-if="$store.state.appconfig.showAppSufix" class="font-weight-light">{{$store.state.appconfig.appname2}}</span>
      </v-toolbar-title>
      <v-btn v-if="$store.state.usuarioLogeado && (this.$route.path != '/agendaResumen')" color="green" dark text @click="$router.push('agendaResumen')">Resumen</v-btn>
      <v-btn v-if="$store.state.usuarioLogeado && (this.$route.path == '/agendaResumen')" color="primary" dark text @click="$router.push('agenda')">Partes</v-btn>
      
      <v-layout row wrap class="versionLayout">
          <span class="versionText">ver.{{$store.state.appversion}}</span>
        </v-layout>
      <v-flex v-if="$store.state.usuarioLogeado" text-sm-right hidden-xs-only mr-15>
        Hola, {{$store.state.usuario.name}}
      </v-flex>           
      <v-btn v-if="$store.state.usuarioLogeado" fab dark small color="blue" class="elevation-5" @click="logout()" fixed right>
        <v-icon large dark>power_settings_new</v-icon>
      </v-btn>
    </v-app-bar>
</template>
<script>

export default {
  name: 'toolbar',
  components: {    
  },
  methods:{
    gohome(){
        if (this.$store.state.usuarioLogeado){
            this.$router.push('Agenda')
        } else{
            this.$router.push('/')
        }
    },
    logout(){
        this.$store.commit("logout");
    },
  },  
  mounted(){    
  }
}
</script>

<style scoped>
.versionText{
  font-size:12px;
  color: rgb(160,160,160);
}
.versionLayout{
  position: absolute;
  margin-top: 37px;
  margin-left: 0px;
}
</style>